// Sentinel player ID representing the aggregated "Chatters" entity in a game
// Sentinel player ID for the aggregated "Chatters" entity.
// Must not begin and end with __ (Firestore field name restriction).
export const CHATTERS_ID = 'chatters';

// Maximum number of regular players allowed per game (excluding chatters).
export const MAX_PLAYERS = 8;

export const GAME_STATUS = {
  WAITING: 'waiting',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

export const ROUND_PHASE = {
  LISTENING: 'listening',
  SONG_SELECTION: 'song_selection',
  SCORING: 'scoring',
  REVEALING: 'revealing',
  ROUND_RESULTS: 'round_results',
};

export const REVEAL_STEP = {
  PREDICTIONS: 'predictions',
  SCORE: 'score',
};
